function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M31.643 44.75h-6.096V30.373H22.5V25.42h3.047v-2.974c0-4.04 1.719-6.445 6.607-6.445h4.068v4.956H33.68c-1.902 0-2.028.692-2.028 1.984l-.009 2.48h4.608l-.54 4.953h-4.068V44.75h.001z"
});

function SvgFacebookLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA2MCI+CiAgPHBhdGggZmlsbD0iZ3JheSIgZD0iTTMxLjY0MyA0NC43NWgtNi4wOTZWMzAuMzczSDIyLjVWMjUuNDJoMy4wNDd2LTIuOTc0YzAtNC4wNCAxLjcxOS02LjQ0NSA2LjYwNy02LjQ0NWg0LjA2OHY0Ljk1NkgzMy42OGMtMS45MDIgMC0yLjAyOC42OTItMi4wMjggMS45ODRsLS4wMDkgMi40OGg0LjYwOGwtLjU0IDQuOTUzaC00LjA2OFY0NC43NWguMDAxeiIvPgo8L3N2Zz4K";
export { SvgFacebookLogoinline as ReactComponent };